module.exports = __webpack_public_path__ + "static/media/close_icon_dark.4e1963b5.svg";